export class JsonDateConverter {
    serialize(property) {
        return property ? property.toISOString() : null;
    }
    deserialize(value) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? undefined : date;
    }
    /* istanbul ignore next */
    collapseArrayWithSingleItem() {
        return false;
    }
}
//# sourceMappingURL=date-converter.js.map